export default __webpack_public_path__ + "static/media/phone_header.48f7ae23.svg";